<script setup lang="ts">
import type { Order } from "@/schemas/order";

defineProps<{
  order: Order;
  paymentUrl: string;
}>();
</script>

<template>
  <div v-if="order.status === 'failed'" class="prose">
    <p>
      Désolé, votre commande n'a pas pu être traitée correctement. Veuillez essayer à nouveau ou nous contacter.
    </p>
    <a :href="paymentUrl" class="btn-orange">Payer</a>
  </div>
  <UiDefaultPage v-else id="checkout" title="Merci pour votre commande">
    <div class="space-y-8">
      <OrderSummary :order="order" />
      <div class="">
        <h2 class="h2 text-primary">
          Détails de la commande
        </h2>
        <OrderItems :items="order.items" />
      </div>
      <OrderCustomer :order="order" />
    </div>
  </UiDefaultPage>
</template>
